<template>
  <div
    v-if="hasErrors"
    class="con-text-validation span-text-validation-danger v-enter-to"
  >
    <span class="span-text-validation" v-if="customError !== ''">
      {{ customError }}
    </span>
    <span v-else class="span-text-validation">
      {{ validatorErrors.first(`${document}.${validation}`)}}
    </span>
  </div>
</template>
<script lang="ts">
export default {
  computed: {
    hasErrors() {
      if (this.validationArray && this.validationArray.length > 0) {
        return this.validationArray.some((v) => this.validatorErrors.has(`${this.document}.${v}`));
      }
      return this.validatorErrors.has(`${this.document}.${this.validation}`);
    }
  },
  props: {
    validatorErrors: {
      type: Object,
      required: true
    },
    document: {
      type: String,
      required: true
    },
    validation: {
      type: String,
    },
    validationArray: {
      type: Array,
      default: () => []
    },
    customError: {
      type: String,
      default: ''
    }
  }
};
</script>
